// extracted by mini-css-extract-plugin
export default {"container":"CategoryForm_container__lRJD1","categoryForm":"CategoryForm_categoryForm__W-hBw","input_box":"CategoryForm_input_box__0I8tC","submit":"CategoryForm_submit__Q9ThI"};